import React from 'react';
import {Stack} from "@fluentui/react/lib/Stack";
import {TextField} from "@fluentui/react";

interface IPriceFiltersProps {
    highPrice?: number;
    lowPrice?: number;
    onChange: (lowPrice?: number, highPrice?: number) => void;
}

const parsePrice = (v?: string): number | undefined => {
    const n = parseFloat(v ?? '');
    return isNaN(n) ? undefined : n;
};

const PriceFilters: React.FC<IPriceFiltersProps> = (props) => {
    // Controlled through local text state: an uncontrolled defaultValue only reads the prop at
    // mount, so criteria arriving after first render (an omnibox price: filter) showed empty
    // fields while the filter was silently applied. The sync-back guard keeps in-progress typing
    // ("100.") intact, since its parsed value already matches the prop.
    const [low, setLow] = React.useState(props.lowPrice?.toString() ?? '');
    const [high, setHigh] = React.useState(props.highPrice?.toString() ?? '');
    React.useEffect(() => {
        if (parsePrice(low) !== props.lowPrice) setLow(props.lowPrice?.toString() ?? '');
    }, [props.lowPrice]);
    React.useEffect(() => {
        if (parsePrice(high) !== props.highPrice) setHigh(props.highPrice?.toString() ?? '');
    }, [props.highPrice]);

    return (
        <Stack tokens={{childrenGap: '0.5em'}} horizontal>
            <TextField
                placeholder={'Low'}
                value={low}
                onChange={(e, p) => {
                    setLow(p ?? '');
                    props.onChange(parsePrice(p), props.highPrice);
                }}
            />
            <TextField
                placeholder={'High'}
                value={high}
                onChange={(e, p) => {
                    setHigh(p ?? '');
                    props.onChange(props.lowPrice, parsePrice(p));
                }}
            />
        </Stack>
    )
}

export default PriceFilters;
